
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getPerformanceMontageTotalsDtoFormGroup() {
return new FormGroup({
    projectsCount: new FormControl<number | undefined>(undefined, [Validators.required]),
    hours: new FormControl<number | undefined>(undefined, [Validators.required]),
    targetHours: new FormControl<number | undefined>(undefined, [Validators.required]),
    revenueExcl: new FormControl<number | undefined>(undefined, [Validators.required]),
    deckungsbeitrag2Target: new FormControl<number | undefined>(undefined, [Validators.required]),
    deckungsbeitrag2Actual: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      